import { api } from "@/client/api";
import { configs } from "@/configs";
import { Staff } from "@/models";

type GetSales = {
  data: Staff[];
  total: number;
};

export async function getSales(query = "") {
  const { data } = await api.get<GetSales>(`${configs.apiUrl}/sales?${query}`);
  return data;
}

export async function getSale(id: number) {
  const { data } = await api.get<Staff>(`${configs.apiUrl}/sales/${id}`);
  return data;
}

// TODO: change url
export async function getSaleByBranch(branchId: number) {
  const data = await api.get<Staff[]>(
    `${configs.apiUrl}/sales/branch/${branchId}`
  );
  return data;
}
